import { request, requestApiOk, requestFormDataApiOk } from './client';
import type { ChangeEmailRequest } from '@/generated/ts-rs/ChangeEmailRequest';
import type { ChangePasswordRequest } from '@/generated/ts-rs/ChangePasswordRequest';
import type { ConfirmEmailChangeRequest } from '@/generated/ts-rs/ConfirmEmailChangeRequest';
import type { ForgotPasswordRequest } from '@/generated/ts-rs/ForgotPasswordRequest';
import type { P12UploadData } from '@/generated/ts-rs/P12UploadData';
import type { ResetPasswordRequest } from '@/generated/ts-rs/ResetPasswordRequest';
import type { TenantLoginRequest } from '@/generated/ts-rs/TenantLoginRequest';
import type { TenantLoginResponse } from '@/generated/ts-rs/TenantLoginResponse';
import type { TenantStatus } from '@/generated/ts-rs/TenantStatus';

export type {
  ChangeEmailRequest,
  ChangePasswordRequest,
  ConfirmEmailChangeRequest,
  ForgotPasswordRequest,
  P12UploadData,
  ResetPasswordRequest,
  TenantLoginRequest,
  TenantLoginResponse,
  TenantStatus,
};

export function login(email: string, password: string): Promise<TenantLoginResponse> {
  const body: TenantLoginRequest = { email, password };
  return request('POST', '/api/tenant/login', body);
}

export function forgotPassword(email: string): Promise<void> {
  const body: ForgotPasswordRequest = { email };
  return requestApiOk('POST', '/api/tenant/forgot-password', body);
}

export function resetPassword(
  email: string,
  code: string,
  newPassword: string,
): Promise<void> {
  const body: ResetPasswordRequest = {
    email,
    code,
    new_password: newPassword,
  };
  return requestApiOk('POST', '/api/tenant/reset-password', body);
}

export function changePassword(
  token: string,
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  const body: ChangePasswordRequest = {
    current_password: currentPassword,
    new_password: newPassword,
  };
  return requestApiOk('POST', '/api/tenant/change-password', body, token);
}

export function changeEmail(
  token: string,
  currentPassword: string,
  newEmail: string,
): Promise<void> {
  const body: ChangeEmailRequest = {
    current_password: currentPassword,
    new_email: newEmail,
  };
  return requestApiOk('POST', '/api/tenant/change-email', body, token);
}

export function confirmEmailChange(
  token: string,
  newEmail: string,
  code: string,
): Promise<void> {
  const body: ConfirmEmailChangeRequest = {
    new_email: newEmail,
    code,
  };
  return requestApiOk('POST', '/api/tenant/confirm-email-change', body, token);
}

export async function uploadSpainVerifactuP12Credential(
  token: string,
  credentialFile: File,
  credentialPassword: string,
): Promise<P12UploadData> {
  const form = new FormData();
  form.append('p12_password', credentialPassword);
  form.append('p12_file', credentialFile);
  return requestFormDataApiOk<P12UploadData>(
    '/api/compliance/spain-verifactu/credentials/p12',
    form,
    token,
  );
}
